import type { FC } from 'react';
import { useState } from 'react';
import { useRouter } from 'next/router';

import { ListItemText, MenuItem, MenuList } from '@packages/shared';
import { ListItemIcon } from '@mui/material';
import { ArrowMediumDown32, ArrowMediumRight32 } from '@packages/themes/dist/icons';
import type { SeoCategoryNavigation } from '../../api/rest/types';

export type SeoProductCategoryNavigationProps = {
  /** The seo category navigation to display. */
  seoCategoryNavigation: SeoCategoryNavigation;
};

/**
 * Displays the given seo category navigation under the "normal" MBA category navigation.
 * */
export const SeoProductCategoryNavigation: FC<SeoProductCategoryNavigationProps> = ({
  seoCategoryNavigation,
}) => {
  const [open, setOpen] = useState(false);
  const { push } = useRouter();

  return (
    <MenuList sx={{ paddingTop: 0 }}>
      <MenuItem sx={{ paddingLeft: 1 }} onClick={() => setOpen(!open)}>
        <ListItemText
          primaryTypographyProps={{
            sx: { overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' },
          }}
        >
          {seoCategoryNavigation.title}
        </ListItemText>
        <ListItemIcon>{open ? <ArrowMediumDown32 /> : <ArrowMediumRight32 />}</ListItemIcon>
      </MenuItem>
      {open &&
        seoCategoryNavigation.items.map((item) => (
          <MenuItem key={item.id} onClick={() => push(item.uriPath)}>
            {item.name}
          </MenuItem>
        ))}
    </MenuList>
  );
};
